import React, { ReactElement } from 'react'
import useSidebarHook from '../hooks/useSideBarHook'

function Sidebar(): ReactElement {
  const { navigation, step } = useSidebarHook()
  const isNavLoaded = navigation && navigation.length > 0

  return (
    <aside
      className={`sidebar colMd3 colLg2 ${
        !isNavLoaded ? 'sidebarIsLoading' : ''
      }`}
    >
      <ul className="sidebarNav listUnstyled">
        {navigation.map((item, index) => {
          let itemVisited = ''
          if (item.done && !item.active) {
            itemVisited = 'sidebarItemVisited'
          }
          return (
            <li
              id = {`step_${index}` }
              key={item.titre}
              className={`sidebarItem ${itemVisited} ${
                step === index ? 'sidebarItemActive' : ''
              }`}
            >
              {item.titre}
            </li>
          )
        })}
      </ul>
      {isNavLoaded && <div className="sidebarMobileSteps" />}
    </aside>
  )
}

export default Sidebar
